document.addEventListener("click", function (e) {

  const openBtn = e.target.closest(".open-size-guide");
  const closeBtn = e.target.closest(".close-size-modal");

  // abrir
  if (openBtn) {
    const type = openBtn.dataset.type;
    const modal = document.getElementById("modal-" + type);

    if (modal) {
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    }
  }

  // cerrar con la X
  if (closeBtn) {
    const modal = closeBtn.closest(".size-modal");

    if (modal) {
      modal.style.display = "none";
      document.body.classList.remove("modal-open");
    }
  }

  // cerrar haciendo click fuera
  const modal = e.target.closest(".size-modal");

  if (modal && e.target === modal) {
    modal.style.display = "none";
    document.body.classList.remove("modal-open");
  }

});
  
  function openTabt(event, tabId) {
    const tabs = document.querySelectorAll(".tab-content-mujer");
    tabs.forEach(tab => tab.style.display = "none");
  
    document.getElementById(tabId).style.display = "block";
  
    const tabLinks = document.querySelectorAll(".tab-link-mujer");
    tabLinks.forEach(link => link.classList.remove("active"));
  
    event.currentTarget.classList.add("active");
    //console.log("hice clickkkkk en la pestana");
  }
  
  let slideIndex = 0;
  
  function showSlide(n) {
    const slides = document.querySelectorAll(".tab-content-mujer:not([style='display: none;']) .slide-mujer");
    slides.forEach(slide => slide.classList.remove("active"));
  
    slideIndex = (n + slides.length) % slides.length;
    slides[slideIndex].classList.add("active");
  }
  
  function changeSlide(n) {
    showSlide(slideIndex + n);
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    openTabt({ currentTarget: document.querySelector(".tab-link-mujer") }, "swimwear-mujer");
    showSlide(0);
  });
  